<template lang="html">
      <footer class="li flex">
            <div class="sli top">
                <template v-for="item in nav">
                    <router-link :key="item.uid" v-if="item.template == 'collections'" class="lundi" :to="{ name: 'collections', params: { collection: item.uid } }">{{ item.title }}</router-link>
                    <router-link :key="item.uid" v-else class="lundi" :to="{ name: item.uid }">{{ item.title }}</router-link>
                </template>
            </div>
            <div class="sli top">
                  <div class="lundi link" @click="toggleCart">Panier</div>
                  <router-link class="lundi" :to="{ name: 'stockist' }"
                  >Stockist</router-link
                  >
                  <router-link class="lundi" :to="{ name: 'conditions' }"
                  >Conditions générales</router-link
                  >
                  <router-link class="lundi" :to="{ name: 'policy' }"
                  >Politique de confidentialité</router-link
                  >
            </div>
            <div class="logo sli f-1 top no-mobile"></div>
            <div class="sli top lundi">
                  <div class="link" @click="toggleNewsletter">Newsletter</div>
                  <a :href="'https://instagram.com/' + site.instagram" target="_blank"
                  >Instagram</a
                  >
                  <a :href="'https://facebook.com/' + site.facebook" target="_blank"
                  >Facebook</a
                  >
                  <a href="mailto:mail@lundipiscine.com">Mail</a>
            </div>
      </footer>
</template>

<script>
export default {
  methods: {
    toggleCart() {
      this.$root.$emit("toggleCart");
    },
    toggleNewsletter() {
      this.$root.$emit("openNewsletter");
    }
  },
  computed: {
    site() {
      return this.$store.state.site;
    },
    nav() {
            return this.$store.state.site.nav;
      },
  }
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  margin-top: calc(4 * var(--lh));
  border-top: 1px solid #000;
  border-bottom: 0 !important;
  a {
    // padding-right: var(--lh);
  }
}
</style>
